/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber21Small = createReactComponent("outline", "number-21-small", "IconNumber21Small", [["path", { "d": "M15 10l2 -2v8", "key": "svg-0" }], ["path", { "d": "M7 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3", "key": "svg-1" }]]);

export { IconNumber21Small as default };
//# sourceMappingURL=IconNumber21Small.mjs.map
